export default __webpack_public_path__ + "img/component-profile-card.51088525.png";